query Statistics($input: StatisticsInput!) {
  statistics(input: $input) {
    totalLeadValue
    totalValuationCount
    totalCommissionValue {
      value
      commission
    }
    totalLeadCount {
      total
      withValuation
      lastThirtyDays
    }
    totalLeadCountByStatus {
      new
      unreached
      newWithValuation
    }
    totalTrafficSource {
      count
      type
    }
  }
}
